import React, { useRef } from 'react';
import { context } from '../../../../context';
import { StatusStyled } from './Styled';
import { Title, Paragraph, Margin, Button, Anchor } from '../../';
import { IContextData } from '../types';

const Already = () => {
  const { history, urlData, dispatchMetrics, brand } = React.useContext<IContextData>(context);
  const redirectToHome = () => history.push('/');
  const divRef = useRef<HTMLDivElement>(null);
  const App = urlData?.app;
  dispatchMetrics('Page:load', {
    Pagetype: 'Avaliacao',
    Pagename: `${brand}:Avaliacao:Avaliação-ja-realizada`,
  });
  const buttonWeb = App ? null : (
    <>
      <Button onClick={redirectToHome} variant="text">
        página inicial
      </Button>
    </>
  );

  React.useEffect(() => {
    divRef?.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <div ref={divRef}>
      <StatusStyled>
        <Title>você já fez essa avaliação</Title>
        <Paragraph>
          Mas se quiser tirar dúvidas ou acompanhar seus pedidos, você pode acessar a Minha Conta ;)
        </Paragraph>
        <Margin bottom={32} />
        <Anchor href="https://cliente.americanas.com.br/minha-conta" variant="secondary">
          minha conta
        </Anchor>
        <Margin bottom={8} />
        {buttonWeb}
      </StatusStyled>
    </div>
  );
};

export default Already;
export { Already };
